module.exports = __webpack_public_path__ + "static/img/39零售.443acff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/39零售.jpg
// module id = 4dxb
// module chunks = 1